import useFeatureFlag from ':src/hooks/useFeatureFlag';
import useViewer from ':src/hooks/useViewer';
import { useQuery } from '@apollo/client';
import { MoDismissableBanner } from '@motivo/guanyin/src/components';
import { Markdown } from '@motivo/guanyin/src/components/Markdown';
import React, { FunctionComponent } from 'react';
import { useDismissable } from '@motivo/guanyin/src/hooks/useDismissable';
import { graphql } from ':src/graphql';
import { isDemoOrganization } from ':src/domains/basic/demoOrganizations';

const activeAppWideBannerQuery = graphql(`
  query ActiveAppWideBannerQuery {
    activeAppWideBanner {
      id
      content
      isDismissable
    }
  }
`);

export type AppWideBannerProps = {};

const AppWideBanner: FunctionComponent<AppWideBannerProps> = () => {
  const isFeatureEnabled = useFeatureFlag('app-wide-banner');
  const { isOpen, onClose } = useDismissable('app-wide-banner');
  const { viewer } = useViewer();
  const isMotivoBasicDemo = isDemoOrganization(viewer.organizationId);

  const { data, loading } = useQuery(activeAppWideBannerQuery);

  if (isMotivoBasicDemo) return null;
  if (!isFeatureEnabled) return null;
  if (loading) return null;
  if (!data?.activeAppWideBanner) return null;

  return (
    <MoDismissableBanner
      isOpen={isOpen}
      onClose={data.activeAppWideBanner.isDismissable ? onClose : undefined}
    >
      <Markdown
        markdown={data.activeAppWideBanner.content}
        linkUtmParams={{
          utm_source: 'app-dashboard',
          utm_medium: 'app-banner',
          utm_campaign: `banner-${data.activeAppWideBanner.id}`,
          utm_content: `org-${viewer.organizationId}`,
          utm_term: `user-${viewer.id}`,
        }}
      />
    </MoDismissableBanner>
  );
};

export default AppWideBanner;
